import { Controller } from "@hotwired/stimulus"
import Handsontable from 'handsontable'
import Papa from "papaparse"

export default class extends Controller {
  static targets = ['container', 'loading']

  connect() {
    const columnKeys = JSON.parse(this.data.get('column-keys'));
    const contentURL = this.data.get('content-url');

    if (contentURL && !columnKeys) {
      this.#loadData(contentURL);
    }
    else {
      this.#loadSpreadsheet(columnKeys);
    }

    // Set up intersection observer (replaces stimulus-use useIntersection)
    this.#setupIntersectionObserver();
  }

  disconnect() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  #setupIntersectionObserver() {
    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.appear(entry);
        }
      });
    });

    this.intersectionObserver.observe(this.element);
  }

  async #loadData(contentURL) {
    const response = await fetch(contentURL);
    const text = await response.text();
    const csvData = Papa.parse(text, {header: true});
    const columnKeys = csvData.meta.fields;

    const spreadsheetElt = this.containerTarget;
    this.handsOnTable = new Handsontable(spreadsheetElt, {
      data: csvData.data,
      rowHeaders: true,
      colHeaders: columnKeys,
      stretchH: 'all',
      contextMenu: true,
      licenseKey: 'non-commercial-and-evaluation'
    });
  }

  #loadSpreadsheet(columnKeys) {
    const spreadsheetElt = this.containerTarget;
    this.handsOnTable = new Handsontable(spreadsheetElt, {
      data: [columnKeys.map(x => "")], // An array of "", columnKeys.length long. i.e. as many empty strings as there are columnKeys.
      rowHeaders: true,
      colHeaders: columnKeys, // An array of strings.
      height: 'auto',
      stretchH: 'all',
      minSpareRows: 1,
      contextMenu: true,
      licenseKey: 'non-commercial-and-evaluation'
    });
  }

  appear(entry) {
    setTimeout(() => {
      if (this.hasLoadingTarget) {
        this.loadingTarget.style.display = 'none';
      }
    }, 10);
  }

  formSubmit(evt) {
    const columnKeys = JSON.parse(this.data.get('column-keys'));
    const outputField = document.querySelector(this.data.get('output-field-id'));
    const data = this.handsOnTable.getData();

    if (columnKeys.length != data[0].length) {
      alert(`The spreadsheet columns must only contain: ${columnKeys}`);
      evt.preventDefault();
      return;
    }

    const mappedData = data.map((elt) => {
      let mappedRow = {};

      for (let i=0; i<columnKeys.length; i++) {
        const key = columnKeys[i];
        mappedRow[key] = elt[i];
      }

      return mappedRow;
    });

    outputField.value = JSON.stringify(mappedData);
  }
}
